import {LOAD_VENUE_LIST, LIST_PAGE_NO} from "../action/actionConstants";

export default function fetchVenueList(state = {list: "", pageNo: 0}, action) {
  switch (action.type) {

    case LOAD_VENUE_LIST : {
      return {...state,
       list: action.payload
     }
   }
      case LIST_PAGE_NO : {
        return {...state,
         pageNo : action.payload
       }
     }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/venueList.js